import { useQuery } from '@tanstack/react-query';
import api from '@/axios';
import type { TransitDetail } from '@/types/core/transit/transit';

export const GET_TRANSIT_KEY = ['transits', 'detail'] as const;

export function useGetTransit(id: string) {
  return useQuery({
    queryKey: [...GET_TRANSIT_KEY, id],
    queryFn: async ({ signal }): Promise<TransitDetail> => {
      const response = await api.get<TransitDetail>(`/transits/${id}`, {
        signal,
      });
      return response.data;
    },
    refetchInterval: (query) =>
      query.state.data?.ddsNeedsRefresh ? 60_000 : false,
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: 'always',
  });
}
